import React, { useState, useMemo, useEffect } from 'react';
import FormFilter from './components/filter';
import {
  Container,
  Button,
} from './styles';
import { T2 } from '../../../styles/titles';
import { PainelVendasFilterProps } from '../../../global/dataTransferObjects/transacoesTempoReal';
import LiveTable from './components/liveTable';
import LoadingOverlay from '../../../components/LoadingOverlay';
import VendaServices from "./services/VendaServices";
import { can, PortalPermissions } from "../../../config/permissions";

const defaultFilter = (): PainelVendasFilterProps => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  return {
    initialDate: `${yyyy}-${mm}-${dd}T00:00:00`,
    finalDate: `${yyyy}-${mm}-${dd}T23:59:59`,
  };
};

const PainelDeVendas: React.FC = () => {
  const [filterData, setFilterData] = useState<PainelVendasFilterProps>(defaultFilter);
  const [totals, setTotals] = useState();
  const vendasServices = useMemo(() => new VendaServices(), []);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFilter = async (filter: PainelVendasFilterProps) => {
    setFilterData(filter);
  };

  const handleDownload = async (type: 'xls' | 'csv', filter?: PainelVendasFilterProps) => {
    try {
      setIsLoading(true);
      await vendasServices.downloadVendas(type, filter);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <LoadingOverlay
        show={isLoading}
        relative
      />
      <T2>Painel De Vendas</T2>
      <FormFilter onFormSubmit={handleFilter} totals={totals} />
      <div>
        {can(PortalPermissions.transacoes.vendas.exportar) && (
          <Button onClick={() => handleDownload('xls', filterData)} style={{ marginBottom: '25px', marginRight: '24px', width: '150px', alignSelf: 'start' }}>Download Xlsx</Button>
        )}
        {can(PortalPermissions.transacoes.vendas.exportar) && (
          <Button onClick={() => handleDownload('csv', filterData)} style={{ marginBottom: '25px', marginRight: '24px', width: '150px', alignSelf: 'start' }}>Download Csv</Button>
        )}
      </div>
      <LiveTable dataFilter={filterData} getTotals={(totals) => setTotals(totals)} />
    </Container>
  );
};

export default PainelDeVendas;
